(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ca-announcement-bar"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const closeButton = document.querySelector('.announcement-bar__close-button');
  const announcementBar = document.querySelector('height-observer[variable="announcement-bar"]');

  if (!closeButton || !announcementBar) {
    return;
  }

  closeButton.addEventListener('click', () => {
    announcementBar.remove();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ca-testimonials"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    observeSettingsChanges();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => observeSettingsChanges());
    }
  });

  function observeSettingsChanges() {
    const observer = new MutationObserver(function(mutations, obs) {
      const swiperElement = document.querySelector('.swiper');

      if (swiperElement && swiperElement.swiper) {
        moveAuthorName();
        const slides_per_view = document.querySelector('.ca-swiper-wrapper').getAttribute('data-slides');
        swiperElement.swiper.params.slidesPerView = slides_per_view || 1;
        swiperElement.swiper.update();

        obs.disconnect();
      }
    });

    const target = document.querySelector('.ca-swiper-wrapper');
    if (!target) return;

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  function moveAuthorName() {
    const authorNameSelector = '.ca-swiper-wrapper [class*=Classic__AuthorName]';
    const targetSelector = '.ca-swiper-wrapper [class*=Supplier__Container]';
    const allSlides = document.querySelectorAll('.ca-swiper-wrapper .swiper-slide');

    [...allSlides].forEach(slide => {
      const author = slide.querySelector(authorNameSelector);
      const target = slide.querySelector(targetSelector);
      if (author && target) {
        target.insertAdjacentElement('beforebegin', author);
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
